import { connect, Dispatch } from 'react-redux';
import DeltaContent from './DeltaContent';
import { RootState } from '../../../../store/reducers';
import { DeltaActions, deltaOptionSelect } from '../../../../store/action/deltaActions';

const mapStateToProps = (state: RootState) => {
    const { deltaReducer } = state;
    const { activePanel, selectedOptions } = deltaReducer;

    return {
        activePanel,
        selectedOptions
    };
};

const mapDispatchToProps = (dispatch: Dispatch<DeltaActions>) => {
    return {
        onChange(option: string, id: string) {
            dispatch(deltaOptionSelect(option, id));
        }
    };
};

const DeltaContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DeltaContent);

export default DeltaContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/DeltaContainer.tsx